// Font brandizzabili per le pagine pubbliche (moduli web, coupon, menu, coda, fidelity).
// Coppie display/body da Google Fonts, caricate on-demand solo quando impostate.
import { useEffect } from "react";

export const BRAND_FONTS = [
  { key: "", label: "Predefinito (Dishenda)", display: null, body: null, url: null },
  {
    key: "elegante", label: "Elegante — Playfair Display + Source Sans",
    display: "'Playfair Display', Georgia, serif", body: "'Source Sans 3', 'Segoe UI', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,700;0,800;1,500&family=Source+Sans+3:wght@400;500;600;700&display=swap",
  },
  {
    key: "gourmet", label: "Gourmet — Cormorant Garamond + Jost",
    display: "'Cormorant Garamond', Georgia, serif", body: "'Jost', 'Segoe UI', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;0,700;1,500&family=Jost:wght@400;500;600;700&display=swap",
  },
  {
    key: "moderno", label: "Moderno — Sora + Inter",
    display: "'Sora', 'Segoe UI', sans-serif", body: "'Inter', 'Segoe UI', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700;800&family=Inter:wght@400;500;600;700&display=swap",
  },
  {
    key: "classico", label: "Classico — Lora + Libre Franklin",
    display: "'Lora', Georgia, serif", body: "'Libre Franklin', 'Segoe UI', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,500;0,600;0,700;1,500&family=Libre+Franklin:wght@400;500;600;700&display=swap",
  },
  {
    key: "minimale", label: "Minimale — Space Grotesk + Work Sans",
    display: "'Space Grotesk', 'Segoe UI', sans-serif", body: "'Work Sans', 'Segoe UI', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Work+Sans:wght@400;500;600;700&display=swap",
  },
];

// Applica il font brand a tutta la pagina pubblica: inietta <link> Google Fonts
// e uno <style> scopato sull'attributo [data-brand-font] (da mettere sul root div).
export function useBrandFont(fontKey) {
  useEffect(() => {
    const f = BRAND_FONTS.find((x) => x.key === fontKey && x.url);
    let st = document.getElementById("brand-font-style");
    if (!f) { if (st) st.remove(); return; }
    if (!document.getElementById("brand-font-link")) {
      const l = document.createElement("link");
      l.id = "brand-font-link"; l.rel = "stylesheet"; l.href = f.url;
      document.head.appendChild(l);
    }
    if (!st) {
      st = document.createElement("style");
      st.id = "brand-font-style";
      document.head.appendChild(st);
    }
    st.textContent = `[data-brand-font]{font-family:${f.body} !important}`
      + `[data-brand-font] .font-display,[data-brand-font] h1{font-family:${f.display} !important}`;
  }, [fontKey]);
}
